export const TAB_KEY_CODE = 9;
export const ESCAPE_KEY_CODE = 27;
export const ARROW_UP_KEY_CODE = 38;
export const ARROW_DOWN_KEY_CODE = 40;
export const ENTER_KEY_CODE = 13;
export const FOCUSABLE_SELECTOR =
  'a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]';
